export default {
    data() {
        return {
            uptiethreadamount: {
                sparkingshardamount: {
                    "EGO": 400,
                    "Rarity000": 400,
                    "Rarity00": 150,
                    "Rarity0": 0,
                },
                IDamount: {
                    "Rarity000": {
                        "from1to2": { thread: 20, shard: 0 },
                        "from2to3": { thread: 80, shard: 0 },
                        "from3to4": { thread: 150, shard: 50 },
                    },
                    "Rarity00": {
                        "from1to2": { thread: 10, shard: 0 },
                        "from2to3": { thread: 40, shard: 0 },
                        "from3to4": { thread: 100, shard: 30 },
                    },
                    "Rarity0": {
                        "from1to2": { thread: 0, shard: 0 },
                        "from2to3": { thread: 0, shard: 0 },
                        "from3to4": { thread: 50, shard: 20 },
                    },
                },
                EGOamount: {
                    "Z": {
                        "from1to2": { thread: 0, shard: 0 },
                        "from2to3": { thread: 0, shard: 0 },
                        "from3to4": { thread: 110, shard: 80 },
                    },
                    "ZnotOriginal": {
                        "from1to2": { thread: 20, shard: 0 },
                        "from2to3": { thread: 60, shard: 0 },
                        "from3to4": { thread: 110, shard: 80 },
                    },
                    "T": {
                        "from1to2": { thread: 25, shard: 0 },
                        "from2to3": { thread: 70, shard: 0 },
                        "from3to4": { thread: 130, shard: 90 },
                    },
                    "H": {
                        "from1to2": { thread: 30, shard: 0 },
                        "from2to3": { thread: 80, shard: 0 },
                        "from3to4": { thread: 150, shard: 100 },
                    },
                    "W": {
                        "from1to2": { thread: 35, shard: 0 },
                        "from2to3": { thread: 90, shard: 0 },
                        "from3to4": { thread: 170, shard: 150 },
                    }
                }
            },
        }
    }
};